import { Button } from '~/components/primitives';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '~/components/ui/dialog';
import { useI18n } from '../i18n';
import { useModalState } from '~/components/primitives/Modal';
import { usePortalCtx } from '~/features/global/portal';
import useCartState from './useCartState';
import { MutationButton } from '~/modules/react-query/components';
import { useQuery } from '@tanstack/react-query';
import type { ClassValue } from 'clsx';
export const Checkout_ContinueButton: React.FC<{
  /** The label */
  children: React.ReactNode;
  className?: ClassValue;
  onSubmit(): void | Promise<unknown>;
  disabled?: boolean;
}> = props => {
  const i18n = useI18n();
  const modal = useModalState(false);
  const portal = usePortalCtx();
  const cartSDK = useCartState();
  const deleteCartItem = cartSDK.useDeleteCartItemMutation({
    silentSuccess: true
  });
  const cartItems = useQuery(cartSDK.cartItemsGrouped_queryOptions());
  return <>
            <Button className={props.className} variant="tertiary" iconAfter="arrow-right" size="lg" disabled={!cartItems.data?.all.length || props.disabled} isLoading={modal.isOpen} data-testid="checkout-proceed" onClick={() => {
      if (!!cartItems.data?.unavailable.length) {
        return modal.open();
      } else {
        return props.onSubmit();
      }
    }}>
                {props.children}
            </Button>

            {modal.isOpen && !!cartItems.data?.unavailable.length && <Dialog open onOpenChange={open => {
      if (!open) modal.close();
    }}>
                    <DialogContent className="sm:max-w-md">
                        <DialogHeader>
                            <DialogTitle>
                                {i18n._('checkout.unavailable-dialog.title', undefined, {
              message: "Some activities can't be booked"
            })}
                            </DialogTitle>
                            <DialogDescription>
                                {i18n._('checkout.unavailable-dialog.description_{bizzName}', {
              bizzName: portal.portal === 'BIZZ' ? portal.bizz.name : ''
            }, {
              message: 'The following activities are not available for {bizzName} and need to be removed before you can continue.'
            })}
                            </DialogDescription>
                        </DialogHeader>
                        <ul className="max-h-48 overflow-y-auto rounded-lg border border-orange-100 bg-orange-50/50">
                            {cartItems.data.unavailable.map(item => <li key={item.id} className="flex items-center gap-3 px-3 py-2">
                                    {item.activity?.media?.header?.path ? <img src={item.activity.media.header.path} alt={item.activity?.name ?? ''} className="h-10 w-14 shrink-0 rounded object-cover" /> : <div className="h-10 w-14 shrink-0 rounded bg-orange-100" />}
                                    <span className="truncate text-sm font-medium text-primary">
                                        {item.activity?.name ?? `#${item.activityId}`}
                                    </span>
                                </li>)}
                        </ul>
                        <DialogFooter className="gap-2 sm:gap-0">
                            <Button variant="outline" onClick={() => modal.close()}>
                                {i18n._('Cancel')}
                            </Button>

                            <MutationButton variant="tertiary" iconBefore="trash" mutationFn={async () => {
            if (!cartItems.data?.unavailable.length) return;
            return Promise.all(cartItems.data.unavailable.map(item_0 => deleteCartItem.mutateAsync({
              id: item_0.id
            })));
          }} onSuccess={() => {
            modal.close();
            if (cartItems.data?.available.length) {
              return props.onSubmit();
            }
          }}>
                                {i18n._('checkout.unavailable-dialog.confirm', undefined, {
              message: 'Remove & continue'
            })}
                            </MutationButton>
                        </DialogFooter>
                    </DialogContent>
                </Dialog>}
        </>;
};